import React from 'react';

import FolderOpenIcon from '@mui/icons-material/FolderOpen';

import { IProgramCollection } from '../../../../types/interfaces/program-collection';
import AppEntityAvatar, {
  AppEntityAvatarProps,
} from '../app-entity-avatar/AppEntityAvatar';

interface AppProgramCollectionAvatarProps extends AppEntityAvatarProps {
  programCollection?: IProgramCollection;
}

export default function AppProgramCollectionAvatar(
  props: AppProgramCollectionAvatarProps,
) {
  const { programCollection, ...avatarProps } = props;
  return (
    <AppEntityAvatar
      {...avatarProps}
      fallbackSeedId={programCollection?.id}
      fallbackSeedName={programCollection?.title}
      directPreviewStorageLink={
        programCollection?.avatar?.directPreviewStorageLink
      }
      directStorageLink={programCollection?.avatar?.directStorageLink}
      previewStorageLink={programCollection?.avatar?.previewStorageLink}
      storageLink={programCollection?.avatar?.storageLink}>
      <FolderOpenIcon />
    </AppEntityAvatar>
  );
}
